import React from "react";
import styles from "./CreateButton.module.css";
import Box from "@mui/material/Box";

function CreateButton({ handleCreateCase, handleClose }) {
  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <button
          type="button"
          className={styles.customButton}
          // onClick={(event) => {
          //   handleCreateCase(event);
          //   handleClose(event);
          // }}
          onClick={async (event) => {
            if (typeof handleCreateCase !== "function") {
              console.error(
                "Submit handler is not registered:",
                handleCreateCase,
              );
              return;
            }

            await handleCreateCase(event);
          }}
        >
          Create Case
        </button>
      </Box>
    </>
  );
}

export default CreateButton;
